// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__1PJ5j","body--phone":"styles_body--phone__2vb7W","intercom-launcher--phone":"styles_intercom-launcher--phone__3nWZg"};